
export default {
  props: {
    product: {
      default: () => {},
    },
  },
}
